import { Image } from '@zoopla/image';
import { ListingSharing } from '@zoopla/listings/share';
import { textStyle } from './Footer.styles.css';
import { ListingUris } from '../../../graphql.generated';

import { Dialog } from '@zoopla-eng/zds/dialog';
import { ButtonLeft, ButtonLinkLeft } from '@zoopla-eng/zds/button';
import {
    ShareWebAndAndroidMedium,
    BinSmall,
    EmailSmall
} from '@zoopla-eng/zds/icons';
import { branchLogoStyle } from './Footer.styles.css';

import { fontGroups } from '@zoopla-eng/zds/themes';

type ShareModalButtonProps = {
    trackOpenShareModal: () => void;
    trackCloseShareModal: () => void;
    testId: string;
    title: string;
    listingId: string;
    listingUris: ListingUris;
};

export const ShareModalButton = ({
    trackOpenShareModal,
    trackCloseShareModal,
    testId,
    title,
    listingId,
    listingUris
}: ShareModalButtonProps) => {
    return (
        <Dialog
            label="Share this property with your friends and family"
            title="Share this property with your friends and family"
            onOpenChange={(open) =>
                open ? trackOpenShareModal() : trackCloseShareModal()
            }
            trigger={
                <ButtonLeft
                    category="tertiary"
                    data-testid={testId}
                    Icon={ShareWebAndAndroidMedium}
                >
                    Share
                </ButtonLeft>
            }
        >
            <ListingSharing
                title={title}
                listingId={listingId}
                listingUrl={listingUris.detail || ''}
                sharingCategory="User Account"
            />
        </Dialog>
    );
};

export const BranchLogo = ({
    logoUrl,
    branchName
}: {
    logoUrl?: string | null;
    branchName?: string | null;
}) => {
    return logoUrl ? (
        <Image
            className={branchLogoStyle}
            src={logoUrl}
            alt={`Marketed by ${branchName}`}
            important
        />
    ) : null;
};

export const PublishedOn = ({
    publishedOn
}: {
    publishedOn?: string | null;
}) => {
    if (!publishedOn) {
        return null;
    }

    const formattedDate = new Intl.DateTimeFormat('en-GB').format(
        Date.parse(publishedOn)
    );
    return (
        <p className={`${textStyle} ${fontGroups.ladle}`}>
            Listed on {formattedDate}
        </p>
    );
};

export const ContactButton = ({
    href,
    onClick,
    testId
}: {
    href: string;
    onClick: () => void;
    testId: string;
}) => (
    <ButtonLinkLeft
        href={href}
        category="tertiary"
        Icon={EmailSmall}
        onClick={onClick}
        data-testid={testId}
    >
        Contact
    </ButtonLinkLeft>
);

export const DeleteButton = ({
    testId,
    onClick
}: {
    testId: string;
    onClick: () => void;
}) => {
    return (
        <ButtonLeft
            category="tertiary"
            onClick={onClick}
            data-testid={testId}
            Icon={BinSmall}
        >
            Remove
        </ButtonLeft>
    );
};
